import React, { useState } from "react";
import { useStyles } from "./style";
import { Button, Grid, Box } from "@material-ui/core";
import clock from "../../../assets/images/sectionClock.png";
import ScoreBox from "../../../assets/images/score_shape.png";
import scoreLeaf from "../../../assets/images/score_leaf.png";
import ReplayOutlinedIcon from "@mui/icons-material/ReplayOutlined";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { Spinner } from "react-bootstrap";
import { getRole } from "../../../Core/utils/auth";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Tooltip, withStyles } from "@material-ui/core";
import { useLocation } from "react-router";

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#FFFFFF",
    color: "#569090",
    border: "0.2px solid #CCCCCC",
    borderRadius: "8px",
    fontSize: 14,
    padding: "8px",
    textAlign: "center",
  },
}))(Tooltip);

const SectionSuccessPage = ({
  sectionLevelData,
  handleNextExercise,
  exercise,
  handleReattempt,
  handleViewResults,
  completedTime,
  reviewStatus,
}) => {
  const classes = useStyles();
  const role = getRole();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const [submissionId, setSubmissionId] = useState(query.get("submissionId"));
  return (
    <Grid
      className={`${classes.flex_col} ${classes.alignItemsCenter} ${classes.fullHeight} ${classes.justifyCenter}`}
    >
      <Box className={classes.scoreContainer}>
        <img src={scoreLeaf} alt="score-leaf" className={classes.scoreLeaf} />
        {sectionLevelData?.percentage !== undefined &&
        sectionLevelData?.scored !== undefined &&
        sectionLevelData?.score !== undefined ? (
          <React.Fragment>
            <Box className={classes.percentageText}>
              {`${sectionLevelData?.percentage}%`}
            </Box>
            <Box className={classes.customScoreBox}>
              <img
                src={ScoreBox}
                alt="score box"
                style={{
                  width: "100%",
                  height: "78px",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  top: "60%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  fontSize: "24px",
                  fontWeight: "700",
                  textAlign: "center",
                  width: "100%",
                }}
                className={classes.scoreText}
              >
                {reviewStatus === "pending" ? (
                  <div className={classes.reviewTextContainer}>
                    <span>In Review</span>
                    {role !== "mentor" && role !== "admin" && (
                      <CustomTooltip title="Score will be shown after the mentor reviews the evaluation">
                        <InfoOutlinedIcon
                          style={{
                            color: "#934d10",
                            height: "16px",
                            width: "16px",
                            marginLeft: "4px",
                          }}
                        />
                      </CustomTooltip>
                    )}
                  </div>
                ) : (
                  `${sectionLevelData?.scored} / ${sectionLevelData?.score}`
                )}
              </div>
            </Box>
          </React.Fragment>
        ) : (
          <Spinner
            animation="border"
            variant="danger"
            style={{ fontSize: "16px" }}
          />
        )}
        <Box className={classes.timerContainer}>
          <img src={clock} alt="fire-clock" className={classes.timerClock} />
          <Box className={classes.completedTime}>
            {completedTime && completedTime}
          </Box>
        </Box>
      </Box>

      <Grid
        className={`${classes.flex_row} ${classes.alignItemsCenter} ${classes.justifyBetween} ${classes.successBtnBox}`}
      >
        {role !== "mentor" && (
          <Button
            className={`${classes.flex_row} ${classes.font700} ${classes.alignItemsCenter} ${classes.successViewBtn}`}
            onClick={handleReattempt}
          >
            Reattempt <ReplayOutlinedIcon fontSize="small" className="ml-2" />
          </Button>
        )}
        <Button
          className={`${classes.flex_row} ${classes.font700} ${
            classes.alignItemsCenter
          } ${classes.successViewBtn} ${
            role !== "mentor" && classes.viewResultsBtn
          }`}
          onClick={handleViewResults}
        >
          {role === "mentor" && submissionId && submissionId.length > 0
            ? "Start review"
            : "View Results"}{" "}
          {role === "mentor" && submissionId && submissionId.length > 0 ? (
            <></>
          ) : (
            <VisibilityOutlinedIcon fontSize="small" className="ml-2" />
          )}
        </Button>
      </Grid>
      {exercise?.nextExercise && (
        <Grid>
          <Button
            className={`${classes.flex_row} ${classes.alignItemsCenter} ${classes.font700} ${classes.font18} ${classes.nextExercise}`}
            onClick={handleNextExercise}
          >
            Next Exercise{" "}
            <ArrowForwardIosOutlinedIcon fontSize="small" className="ml-1" />
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default SectionSuccessPage;
